import { render, staticRenderFns } from "./Propiedades.vue?vue&type=template&id=992e695e&scoped=true&"
import script from "./Propiedades.vue?vue&type=script&lang=js&"
export * from "./Propiedades.vue?vue&type=script&lang=js&"
import style0 from "./Propiedades.vue?vue&type=style&index=0&id=992e695e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992e695e",
  null
  
)

export default component.exports